import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthLayoutComponent } from '@features/auth/shared/components/auth-layout/auth-layout.component';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { navigateWithQueryParams } from '@features/auth/shared/redirect/redirect-helper';
import { WEB_ROUTE_SSO_XAC_MINH_LAN_DAU } from '@features/auth/const';

@Component({
  standalone: true,
  imports: [CommonModule, AuthLayoutComponent, TranslocoModule],
  selector: 'app-sso-error-view',
  templateUrl: './error-view.component.html',
  styleUrls: ['./error-view.component.css'],
})
export class SSOErrorViewComponent implements OnInit {
  private readonly router = inject(Router);
  constructor() { }

  ngOnInit() { }

  navigateToLogin() {
    // this.router.navigate([WEB_ROUTE_SSO_XAC_MINH_LAN_DAU]);
    navigateWithQueryParams(this.router, [WEB_ROUTE_SSO_XAC_MINH_LAN_DAU]);
  }
}
